/*
 * @Author: Dong
 * @Date: 2022-04-11 16:19:06
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-04 10:53:56
 */
import { defineMessages } from 'react-intl';

const object: { [key: string]: string } = {
  tip: '您的浏览器不支持canvas标签。',
};

export default defineMessages(object);
